import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-34">
      {children}
    </motion.div>;
}